import React, { useState, useEffect, useRef } from "react";
import Img_person from "../../images/icons/person.svg";
import goldLevelImage from "../../images/Gold-level.png";
import silverLevelImage from "../../images/Silver-level.png";
import platinumLevelImage from "../../images/Platinum-level.png";
import goldBadge from "../../images/icons/gold_badge.svg";
import platinumBadge from "../../images/icons/platinum_badge.svg";
import chevron from "../../images/icons/chevron.svg";
import chevronWhite from "../../images/icons/chevron-white.svg";
import Img_rank from "../../images/icons/rank.svg";
import payByPoints from "../../images/icons/claim-pay-with-points.svg";
import rewardsVoucher from "../../images/icons/claim-rewards-voucher.svg";
import hotelIcon from "../../images/icons/hotel-icon.svg";
import expiredDateIcon from "../../images/icons/expired-date-icon.svg";
import qrCodeIcon from "../../images/icons/qr-code-icon.svg";
import { navigate } from "gatsby";
import RewardDetailDrawer from "./RewardsDetailDrawer";
import QRCodeDrawer from "./QRCodeDrawer";
import { Progress } from "antd";
import { useSelector } from "react-redux";
import MemberShipLevelDetail from "./MemberShipLevelDetail";

const AccountBar = ({ langData, userData, locale, location, openWidgetAction }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isPointsDrawerOpen, setIsPointsDrawerOpen] = useState(false);
  const [isMemberDetailDrawerOpen, setIsMemberDetailDrawerOpen] = useState(
    false
  );
  const [isQRDrawerOpen, setIsQRDrawerOpen] = useState(false);
  const prevMemberDetailOpen = useRef(false);

  const guestInformation = useSelector(
    (store) => store.guestInformation.member.data
  );

  useEffect(() => {
    const hash =
      location?.hash ||
      (typeof window !== "undefined" ? window.location.hash : "");
    if (hash === "#level-details" && guestInformation) {
      setIsMemberDetailDrawerOpen(true);
    }
  }, [location?.hash, guestInformation]);

  // Fallback: check window.location.hash on mount/data load (covers redirect from callback)
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash === "#level-details" && guestInformation) {
      setIsMemberDetailDrawerOpen(true);
    }
  }, [guestInformation]);

  useEffect(() => {
    if (
      prevMemberDetailOpen.current &&
      !isMemberDetailDrawerOpen &&
      typeof window !== "undefined" &&
      window.location.hash === "#level-details"
    ) {
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}${window.location.search}`
      );
    }
    prevMemberDetailOpen.current = isMemberDetailDrawerOpen;
  }, [isMemberDetailDrawerOpen]);

  const guest = guestInformation?.guest;
  const rewardsInfo = guestInformation?.rewardsInfo;

  const fullName = guestInformation
    ? `${guest?.firstName} ${guest?.lastName}`
    : userData?.fullname;

  const level = guestInformation ? rewardsInfo?.level : userData?.level;
  const points = guestInformation ? rewardsInfo?.points : userData?.balance;
  const expiryDate = guestInformation
    ? rewardsInfo?.pointsExpiry
    : userData?.pointsExpiryDate;

  const levelValidity = guestInformation
    ? rewardsInfo?.levelValidity
    : userData?.levelValidity;
  const toPositive = (value) => (value < 0 ? -value : value || 0);

  const levelPointsToRetain = guestInformation
    ? toPositive(rewardsInfo?.levelPointsToRetain)
    : toPositive(userData?.levelPointsToRetain);

  const nightsToRetain = guestInformation
    ? toPositive(rewardsInfo?.nightsToRetain)
    : toPositive(userData?.nightsToRetain);

  const nightsNeededToNextLevel = guestInformation
    ? toPositive(rewardsInfo?.nightsNeededToNextLevel)
    : toPositive(userData?.nightsNeededToNextLevel);

  const levelPointsBalanceNumerator = guestInformation
    ? toPositive(rewardsInfo?.levelPointsBalanceNumerator)
    : toPositive(userData?.levelPointsBalanceNumerator);

  const levelPointsBalanceDenominator = guestInformation
    ? toPositive(rewardsInfo?.levelPointsBalanceDenominator)
    : toPositive(userData?.levelPointsBalanceDenominator);

  const nightsNumerator = guestInformation
    ? toPositive(rewardsInfo?.nightsNumerator)
    : toPositive(userData?.nightsNumerator);

  const nightsDenominator = guestInformation
    ? toPositive(rewardsInfo?.nightsDenominator)
    : toPositive(userData?.nightsDenominator);

  const levelPointsProgressBar = guestInformation
    ? toPositive(rewardsInfo?.levelPointsProgressBar)
    : toPositive(userData?.levelPointsProgressBar);

  const levelPointsProgressBarMaxLevel = guestInformation
    ? toPositive(rewardsInfo?.levelPointsProgressBarMaxLevel)
    : toPositive(userData?.levelPointsProgressBarMaxLevel);

  const nightsProgressBar = guestInformation
    ? toPositive(rewardsInfo?.nightsProgressBar)
    : toPositive(userData?.nightsProgressBar);

  const nightsProgressBarMaxLevel = guestInformation
    ? toPositive(rewardsInfo?.nightsProgressBarMaxLevel)
    : toPositive(userData?.nightsProgressBarMaxLevel);

  const experienceForNextLevel = guestInformation
    ? rewardsInfo?.experienceNeededToNextLevel
    : userData?.experienceNeededToNextLevel;

  const pointsProgressPercent =
    (levelPointsProgressBar / levelPointsProgressBarMaxLevel) * 100;

  const nightsProgressPercent =
    (nightsProgressBar / nightsProgressBarMaxLevel) * 100;

  const capitalizeFirstLetter = (str) => {
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
  };

  const handleClaimRewardsClick = () =>
    points >= 500 ? setIsDrawerOpen(!isDrawerOpen) : openWidgetAction();

  const date = new Date(`${levelValidity}`);
  const options = { day: "numeric", month: "long", year: "numeric" };
  date.setDate(date.getDate() + 1);

  return (
    <>
      <div className="tw-w-screen sm:tw-w-[375px] tw-overflow-x-hidden tw-gap-6 tw-flex tw-flex-col tw-mb-5">
        <div
          style={{
            border: "1px solid #F2F0EB",
          }}>
          <div className="tw-p-4 tw-gap-2 tw-flex tw-flex-row tw-justify-between tw-items-center">
            {/* First Column - Member Information */}
            <div className="tw-flex tw-flex-col tw-gap-2 tw-flex-1">
              <div className="account__bar__content">
                <span 
                  className="tw-font-gotham tw-font-bold"
                  style={{
                    fontSize: '20px',
                    lineHeight: '100%',
                    letterSpacing: '-0.4px',
                    color: '#111111'
                  }}
                >
                  {fullName}
                </span>
              </div>
              <div className="tw-flex tw-flex-col">
                <span 
                  className="tw-font-opensans tw-font-normal"
                  style={{
                    fontSize: '14px',
                    lineHeight: '100%',
                    letterSpacing: '0px',
                    color: '#464646'
                  }}
                >
                  {userData?.formatted_ayana_reward_id ? userData?.formatted_ayana_reward_id : ''}
                </span>
              </div>
            </div>
            
            {/* Second Column - QR Code */}
            <div className="tw-flex tw-justify-center tw-items-center tw-ml-4">
              <button
                onClick={() => setIsQRDrawerOpen(true)}
                className="tw-p-2 tw-cursor-pointer hover:tw-bg-gray-100 tw-rounded tw-bg-transparent"
              >
                <img src={qrCodeIcon} alt="QR Code" width={28} height={28} />
              </button>
            </div>
          </div>

          <div className="tw-py-3 tw-px-4 tw-gap-4 tw-flex tw-flex-col tw-bg-[#FAF9F8]">
            <div className="tw-flex tw-justify-between">
              <span className="tw-font-semibold tw-leading-5">
                {langData.rewards_points}
              </span>
              <button
                className="tw-font-normal tw-leading-5 tw-underline tw-underline-offset-1 tw-bg-transparent tw-cursor-pointer tw-p-0"
                onClick={() => setIsPointsDrawerOpen(!isPointsDrawerOpen)}>
                {langData.learn_more}
                <img src={chevron}></img>
              </button>
            </div>

            <div className="tw-flex tw-justify-between tw-items-center">
              <div className="tw-flex tw-flex-col">
                <div className="tw-font-semibold tw-leading-5 tw-flex tw-align-items-center tw-gap-1">
                  <img src={Img_rank} alt="" />

                  <span className="tw-font-normal tw-leading-6 tw-text-[20px] tw-text-[#37B0E5] tw-font-gotham">
                    {points != null ? points.toLocaleString() : ''}{" "}
                  </span>
                </div>
                {points > 0 && (
                  <span className="tw-font-normal tw-text-[#747474]">
                    {`${langData.expires_on} ${expiryDate}`}
                  </span>
                )}
              </div>

              <button
                className="tw-py-2 tw-px-4 tw-bg-[#52C0E9] tw-text-white tw-font-gotham tw-cursor-pointer tw-text-center tw-tracking-[0.5px]"
                onClick={handleClaimRewardsClick}>
                {points >= 500
                  ? `${langData.claim_rewards}`
                  : `${langData.earn_points}`}
              </button>
            </div>
          </div>
        </div>

        <div
          className={`tw-w-full tw-overflow-x-hidden tw-bg-cover tw-bg-center tw-bg-no-repeat ${level === "Platinum" && "tw-text-white"
            }`}
          style={{
            backgroundImage: `${level == "Silver"
                ? `url(${silverLevelImage})`
                : level == "Gold"
                  ? `url(${goldLevelImage})`
                  : `url(${platinumLevelImage})`
              }`,
          }}>
          <div className="tw-p-4 tw-gap-2 tw-flex tw-flex-col">
            <div className="tw-text-[20px] tw-leading-6 tw-tracking-[-0.4px] tw-font-normal tw-font-gotham">
              {level ? capitalizeFirstLetter(level) : ''} Level
            </div>
            {locale == "en" && (
              <div className="tw-font-normal tw-leading-5">
                {level == "Platinum" &&
                  (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
                    nightsProgressBar >= nightsProgressBarMaxLevel)
                  ? "Level successfully maintained and it will be automatically extended on"
                  : level == "Platinum"
                    ? "Achieve one of the goals below to maintain your"
                    : "Achieve one of the goals below to upgrade to"}
                {!(
                  level == "Platinum" &&
                  (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
                    nightsProgressBar >= nightsProgressBarMaxLevel)
                ) && (
                    <>
                      <span className="tw-font-bold tw-leading-5">
                        {" "}
                        {level == "Silver"
                          ? "Gold Level"
                          : level == "Gold"
                            ? "Platinum Level"
                            : "Platinum Level"}
                      </span>{" "}
                      before
                    </>
                  )}{" "}
                {level == "Platinum" &&
                  (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
                    nightsProgressBar >= nightsProgressBarMaxLevel) ? (
                  <span className="tw-font-bold tw-leading-5">
                    {date.toLocaleDateString("en-GB", options)}
                  </span>
                ) : (
                  <span className="tw-font-bold tw-leading-5">
                    {levelValidity}
                  </span>
                )}
              </div>
            )}
            {locale === "ja" && (
              <div className="tw-font-normal tw-leading-5">
                {level == "Platinum" &&
                  (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
                    nightsProgressBar >= nightsProgressBarMaxLevel) ? (
                  <>
                    レベルは正常に維持され、{" "}
                    <span className="tw-font-bold tw-leading-5">
                      {date.toLocaleDateString("en-GB", options)}{" "}
                    </span>
                    に自動的に延長されます。
                  </>
                ) : level == "Platinum" ? (
                  <>
                    下記の目標の1つを達成し、{" "}
                    <span className="tw-font-bold tw-leading-5">
                      {levelValidity}{" "}
                    </span>
                    までに{" "}
                    <span className="tw-font-bold tw-leading-5">
                      {level === "Silver" ? "ゴールドレベル" : "プラチナレベル"}
                    </span>
                    レベルを維持してください
                  </>
                ) : (
                  <>
                    以下の目標のいずれかを達成して、{" "}
                    <span className="tw-font-bold tw-leading-5">
                      {levelValidity}
                    </span>{" "}
                    前に{" "}
                    <span className="tw-font-bold tw-leading-5">
                      {level === "Silver" ? "ゴールドレベル" : "プラチナレベル"}
                    </span>{" "}
                    にアップグレードしてください
                  </>
                )}
              </div>
            )}
            {locale === "zh" && (
              <div className="tw-font-normal tw-leading-5">
                {level == "Platinum" &&
                  (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
                    nightsProgressBar >= nightsProgressBarMaxLevel) ? (
                  <>
                    级别成功维护，并将在{" "}
                    <span className="tw-font-bold tw-leading-5">
                      {date.toLocaleDateString("en-GB", options)}
                    </span>
                    自动延续。
                  </>
                ) : level === "Platinum" ? (
                  <>
                    在到期前达成以下一个目标，以保持您的{" "}
                    <span className="tw-font-bold tw-leading-5">
                      {level === "Silver" ? "黄金级别" : "白金级别"}
                    </span>
                    <span className="tw-font-bold tw-leading-5">
                      等级 {levelValidity}
                    </span>
                  </>
                ) : (
                  <>
                    在{" "}
                    <span className="tw-font-bold tw-leading-5">
                      {levelValidity}
                    </span>
                    之前达成以下目标之一以升级到
                    <span className="tw-font-bold tw-leading-5">
                      {level === "Silver" ? "黄金级别" : "白金级别"}
                    </span>
                  </>
                )}
              </div>
            )}
            <div className="tw-flex tw-items-center tw-justify-start tw-mt-1">
              <div
                className={`${level === "Platinum" ? "tw-w-full" : "tw-w-[303px]"
                  } tw-flex tw-flex-col tw-items-start`}>
                {level == "Platinum" &&
                  (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
                    nightsProgressBar >= nightsProgressBarMaxLevel) ? (
                  <span
                    className={`tw-leading-5 tw-font-semibold tw-text-[#464646] ${level === "Platinum" ? "tw-text-white" : ""
                      }`}>
                    {locale == "en"
                      ? `${levelPointsBalanceNumerator ? levelPointsBalanceNumerator.toLocaleString() : ''} Level Points Earned`
                      : locale == "ja"
                        ? `${levelPointsBalanceNumerator ? levelPointsBalanceNumerator.toLocaleString() : ''}レベルポイント獲得`
                        : locale == "zh"
                          ? `获得 ${levelPointsBalanceNumerator ? levelPointsBalanceNumerator.toLocaleString() : ''}等级积分`
                          : ""}
                  </span>
                ) : (
                  <span
                    className={`tw-leading-5 tw-font-semibold tw-text-[#464646] ${level === "Platinum" ? "tw-text-white" : ""
                      }`}>
                    {locale == "en"
                      ? `Earn ${level == "Platinum"
                        ? levelPointsToRetain ? levelPointsToRetain.toLocaleString() : ''
                        : experienceForNextLevel ? experienceForNextLevel.toLocaleString() : ''
                      } more Level Points`
                      : locale == "ja"
                        ? `あと${level == "Platinum"
                          ? levelPointsToRetain ? levelPointsToRetain.toLocaleString() : ''
                          : experienceForNextLevel ? experienceForNextLevel.toLocaleString() : ''
                        }ポイントを獲得する`
                        : locale == "zh"
                          ? `额外获得${level == "Platinum"
                            ? levelPointsToRetain ? levelPointsToRetain.toLocaleString() : ''
                            : experienceForNextLevel ? experienceForNextLevel.toLocaleString() : ''
                          }等级积分`
                          : ""}
                  </span>
                )}
                {level == "Platinum" &&
                  (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
                    nightsProgressBar >= nightsProgressBarMaxLevel) ? (
                  <Progress
                    width={280}
                    percent={pointsProgressPercent}
                    showInfo={false}
                    strokeColor="#979797"
                    trailColor="#E0E0E0"
                  />
                ) : (
                  <Progress
                    width={280}
                    percent={pointsProgressPercent}
                    showInfo={false}
                    strokeColor="#3E7FA5"
                    trailColor="#E0E0E0"
                  />
                )}
              </div>
              {level !== "Platinum" && (
                <div className="tw-w-10 tw-flex tw-flex-col tw-items-center tw-ml-4 md:tw-ml-6">
                  <span className="tw-text-[12px] tw-leading-4 tw-font-semibold">
                    {level === "Silver"
                      ? "Gold"
                      : level === "Gold"
                        ? "Platinum"
                        : "Platinum"}
                  </span>
                  <img
                    src={
                      level === "Silver"
                        ? goldBadge
                        : level === "Gold"
                          ? platinumBadge
                          : platinumBadge
                    }
                    alt={level}
                    className="tw-mt-1"
                  />
                </div>
              )}
            </div>
            <div className="tw-w-[24px] tw-h-[24px] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-gap-2.5  tw-bg-[#FAFAFA] tw-opacity-60">
              <span className="tw-font-normal tw-font-gotham tw-text-[12px] tw-leading-3 tw-tracking-[-0.4px] tw-text-[#464646] ">
                {langData.or}
              </span>
            </div>
            <div className="tw-flex tw-items-center tw-justify-start tw-mt-1">
              <div
                className={`${level === "Platinum" ? "tw-w-full" : "tw-w-[303px]"
                  } tw-flex tw-flex-col tw-items-start`}>
                <span
                  className={`tw-leading-5 tw-font-semibold tw-text-[#464646] ${level === "Platinum" ? "tw-text-white" : ""
                    }`}>
                  {locale == "en"
                    ? level == "Platinum" &&
                      (levelPointsProgressBar >=
                        levelPointsProgressBarMaxLevel ||
                        nightsProgressBar >= nightsProgressBarMaxLevel)
                      ? `${nightsProgressBarMaxLevel} Nights Stayed`
                      : level == "Platinum"
                        ? `Stay ${nightsToRetain} more Nights`
                        : `Stay ${nightsNeededToNextLevel} more Nights`
                    : locale == "ja"
                      ? level == "Platinum" &&
                        (levelPointsProgressBar >=
                          levelPointsProgressBarMaxLevel ||
                          nightsProgressBar >= nightsProgressBarMaxLevel)
                        ? `${nightsProgressBarMaxLevel} 泊の滞在`
                        : level == "Platinum"
                          ? `さらに ${nightsToRetain} 泊を滞在する`
                          : `さらに ${nightsNeededToNextLevel} 泊を滞在する`
                      : locale == "zh"
                        ? level == "Platinum" &&
                          (levelPointsProgressBar >=
                            levelPointsProgressBarMaxLevel ||
                            nightsProgressBar >= nightsProgressBarMaxLevel)
                          ? `${nightsProgressBarMaxLevel} 晚住宿`
                          : level == "Platinum"
                            ? `再住 ${nightsToRetain} 晚`
                            : `再住 ${nightsNeededToNextLevel} 晚`
                        : ""}
                </span>
                {level == "Platinum" &&
                  (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
                    nightsProgressBar >= nightsProgressBarMaxLevel) ? (
                  <Progress
                    width={280}
                    percent={nightsProgressPercent}
                    showInfo={false}
                    strokeColor="#979797"
                    trailColor="#E0E0E0"
                  />
                ) : (
                  <Progress
                    width={280}
                    percent={nightsProgressPercent}
                    showInfo={false}
                    strokeColor="#3E7FA5"
                    trailColor="#E0E0E0"
                  />
                )}
              </div>
              {level !== "Platinum" && (
                <div className="tw-w-10 tw-flex tw-flex-col tw-items-center tw-ml-4 md:tw-ml-6">
                  <span className="tw-text-[12px] tw-leading-4 tw-font-semibold tw-text-[#464646]">
                    {level === "Silver"
                      ? "Gold"
                      : level === "Gold"
                        ? "Platinum"
                        : "Platinum"}
                  </span>
                  <img
                    src={level === "Silver" ? goldBadge : platinumBadge}
                    alt={level}
                    className="tw-mt-1"
                  />
                </div>
              )}
            </div>
            <button
              className="tw-font-normal tw-leading-5 tw-underline tw-underline-offset-1 tw-bg-transparent tw-cursor-pointer tw-p-0 tw-text-left"
              onClick={() =>
                setIsMemberDetailDrawerOpen(!isMemberDetailDrawerOpen)
              }>
              {level == "Platinum"
                ? `${langData.maintain_level}`
                : `${langData.upgrade_level}`}
              <img src={level == "Platinum" ? chevronWhite : chevron}></img>
            </button>
          </div>
        </div>
      </div>
      {/* Claim Rewards */}
      {isDrawerOpen && (
        <RewardDetailDrawer setIsDrawerOpen={setIsDrawerOpen}>
          <div className="tw-text-[16px] md:tw-text-[20px] tw-leading-5 md:tw-leading-[28px] tw-text-[#464646] tw-font-opensans tw-font-semibold">
            {langData.claim_rewards_popup_drawer_title}
          </div>
          <div className="tw-text-[14px] tw-leading-[21px] tw-text-[#464646] tw-font-opensans tw-font-normal">
            {langData.claim_rewards_popup_drawer_description}
          </div>
          <div className="tw-text-[14px] tw-leading-[21px] tw-text-[#464646] tw-font-opensans tw-font-normal">
            {langData.claim_rewards_popup_drawer_explore}
          </div>
          <button
            className="tw-rounded-[8px] tw-gap-2 tw-px-3 tw-py-2 tw-flex tw-justify-center tw-items-center tw-bg-transparent tw-cursor-pointer"
            style={{
              border: "1px solid #CACACA",
            }}
            onClick={() =>
              navigate(
                `${locale !== "en"
                  ? `/${locale}/pay-with-points`
                  : "/pay-with-points"
                }`
              )
            }>
            <img src={payByPoints} width={48} height={48}></img>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-text-[#464646] tw-font-opensans tw-items-start tw-w-[275px]">
              <div className="tw-text-[14px] tw-leading-4 tw-font-semibold">
                {langData.claim_rewards_popup_drawer_pay_with_points}
              </div>
              <div className="tw-text-[12px] tw-leading-5 tw-font-normal tw-text-left">
                {
                  langData.claim_rewards_popup_drawer_pay_with_points_description
                }
              </div>
            </div>
            <img src={chevron}></img>
          </button>
          <button
            className="tw-rounded-[8px] tw-gap-2 tw-px-3 tw-py-2 tw-flex tw-justify-center tw-items-center tw-bg-transparent tw-cursor-pointer"
            style={{
              border: "1px solid #CACACA",
            }}
            onClick={() =>
              navigate(
                `${locale !== "en"
                  ? `/${locale}/reward?page=1`
                  : "/reward?page=1"
                }`
              )
            }>
            <img src={rewardsVoucher} width={48} height={48}></img>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-text-[#464646] tw-font-opensans tw-items-start tw-w-[275px]">
              <div className="tw-text-[14px] tw-leading-4 tw-font-semibold">
                {langData.claim_rewards_popup_drawer_voucher}
              </div>
              <div className="tw-text-[12px] tw-leading-5 tw-font-normal tw-text-left">
                {langData.claim_rewards_popup_drawer_voucher_description}
              </div>
            </div>
            <img src={chevron}></img>
          </button>
        </RewardDetailDrawer>
      )}
      {/* Rewards Points */}
      {isPointsDrawerOpen && (
        <RewardDetailDrawer setIsDrawerOpen={setIsPointsDrawerOpen}>
          <div className="tw-text-[16px] md:tw-text-[20px] tw-leading-5 md:tw-leading-[28px] tw-text-[#464646] tw-font-opensans tw-font-semibold">
            {langData.rewards_points_title}
          </div>
          <div className="tw-gap-3 tw-flex tw-flex-col">
            <div className="tw-flex tw-justify-between tw-items-start tw-text-[14px] tw-font-normal tw-gap-2 tw-tracking-wide">
              <img src={hotelIcon} height={48} width={48}></img>
              <div className="tw-leading-5">
                {langData.rewards_points_description}
                <br></br>
                <button
                  className="tw-text-[#37B0E5] tw-bg-transparent tw-p-0 tw-cursor-pointer"
                  onClick={() =>
                    locale == "zh"
                      ? `${navigate(
                        "/zh/terms-and-conditions-8#points-earning"
                      )}`
                      : locale == "ja"
                        ? `${navigate(
                          "/ja/terms-and-conditions-8#points-earning"
                        )}`
                        : `${navigate("/terms-and-conditions-8#points-earning")}`
                  }>
                  {langData.rewards_points_terms_conditions}
                </button>
              </div>
            </div>
            <div className="tw-flex tw-justify-between tw-text-[14px] tw-font-normal tw-gap-2 tw-tracking-wide">
              <img src={expiredDateIcon} height={48} width={48}></img>
              <div className="tw-leading-5">
                {langData.rewards_points_expiration_detail}
              </div>
            </div>
          </div>
        </RewardDetailDrawer>
      )}
      {isMemberDetailDrawerOpen && (
        <RewardDetailDrawer
          setIsDrawerOpen={setIsMemberDetailDrawerOpen}
          isMembershipDetail={true}>
          <MemberShipLevelDetail
            locale={locale}
            membershipLevel={capitalizeFirstLetter(level)}
            openWidgetAction={openWidgetAction}
            setIsDrawerOpen={setIsMemberDetailDrawerOpen}
            nightsToRetain={nightsToRetain}
            nightsNeededToNextLevel={nightsNeededToNextLevel}
            levelPointsToRetain={levelPointsToRetain}
            experienceForNextLevel={experienceForNextLevel}
            levelValidity={levelValidity}
            levelPointsBalanceNumerator={levelPointsBalanceNumerator}
            levelPointsBalanceDenominator={levelPointsBalanceDenominator}
            nightsNumerator={nightsNumerator}
            nightsDenominator={nightsDenominator}
            langData={langData}
            levelPointsProgressBar={levelPointsProgressBar}
            levelPointsProgressBarMaxLevel={levelPointsProgressBarMaxLevel}
            nightsProgressBar={nightsProgressBar}
            nightsProgressBarMaxLevel={nightsProgressBarMaxLevel}
          />
        </RewardDetailDrawer>
      )}
      {/* QR Code Drawer */}
      <QRCodeDrawer
        isOpen={isQRDrawerOpen}
        onClose={() => setIsQRDrawerOpen(false)}
        langData={langData}
      />
    </>
  );
};

export default AccountBar;